import { CONTACT_DIALOG_MESSAGES, ContactDialogMessages } from "./contact-dialog.messages";
import { CONTACTS_FILTER_MESSAGES, ContactFiltersMessages } from "./contact-filters.messages";
import { CONTACTS_TABLE_MESSAGES, ContactsTableMessages } from "./contacts-table.messages";
import { CONTACTS_IMPORT_MESSAGES, ContactsImportMessages } from "./import-contact-dialog.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";

export type ContactsMessages = ContactsTableMessages &
  ContactFiltersMessages &
  SidebarMessages &
  ContactDialogMessages &
  ContactsImportMessages & {
    contactsPageTitle: string;
    contactBreadCrumbTitle: string;
    contactNotFoundError: string;
    contactNotFoundDescription: string;
    contactNotFoundAlt: string;
    contactErrorToLoad: string;

    //Create Button
    addContactButton: string;
  };

export const CONTACTS_MESSAGES: ContactsMessages = {
  contactsPageTitle: "Contatos",
  contactBreadCrumbTitle: "Contatos",

  contactNotFoundError: "Contato não encontrado",
  contactNotFoundDescription: "Não conseguimos encontrar o contato que você está procurando",
  contactNotFoundAlt: "Contato não encontrado",
  contactErrorToLoad: "Erro ao carregar o contato",

  //Create Button
  addContactButton: "Novo Contato",

  ...SIDEBAR_MESSAGES,
  ...CONTACTS_TABLE_MESSAGES,
  ...CONTACTS_FILTER_MESSAGES,
  ...CONTACT_DIALOG_MESSAGES,
  ...CONTACTS_IMPORT_MESSAGES,
};

export default CONTACTS_MESSAGES;
